import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

// Simple ID generator
const generateId = () => Math.random().toString(36).substr(2, 9) + Date.now().toString(36);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const showToast = useCallback((message, type = 'info', duration = null) => {
    const id = generateId();
    const newToast = {
      id,
      message,
      type, // 'success', 'error', 'warning', 'info'
      duration: duration !== null ? duration : (type === 'success' ? 5000 : null) // Auto-dismiss success after 5s, others manual
    };

    setToasts(prev => [...prev, newToast]);

    // Auto-dismiss if duration is set
    if (newToast.duration) {
      setTimeout(() => {
        removeToast(id);
      }, newToast.duration);
    }

    return id;
  }, [removeToast]);

  const value = {
    toasts,
    showToast,
    removeToast
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );
};

